// dependencies.
import { useState } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
// components.
import AuthTemplate from '../../templates/AuthScreen'
import { Label } from '../../components/Typography'
// constants.
import { DEFAULT_FORM } from './constants'
import { SIGN_UP_ENABLED } from '../../constants'
import { getUserByDocument, getUserByDocumentAndCode } from '../../js/firebase/firebase'
import { Loader } from '../../components/Icon'
import { signIn } from '../../js/auth/authActions'
import { useAppDispatch } from '../../js/store/hooks'

/************************/
/*                      */
/*    Sign In Screen    */
/*                      */
/************************/

// partials.
const StyledButtons = styled.div({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  justifyContent: 'center',
  margin: '40px auto',
  maxWidth: 360,
})

const SubmitError = styled(Label)({
  display: 'block',
  margin: '0 auto',
  maxWidth: 360,
  textAlign: 'center',
  width: '100%',
})

const SigninScreen = () => {
  const navigate = useNavigate()
  const [document, setDocument] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const [formErrors, setFormErrors] = useState({})
  const dispatch = useAppDispatch()
  const handleTogglePasswordVisibility = () => setShowPassword((prev) => !prev)

  const signinForm = DEFAULT_FORM.map((field) => {
    if (field.name !== 'password') return field
    return {
      ...field,
      type: showPassword ? 'text' : 'password',
      iconR: 'view',
      iconRColor: showPassword ? 'black' : 'ash',
      handleIconRClick: handleTogglePasswordVisibility,
    }
  })

  const handleValueChange = (values) => {
    const { document, password } = values
    setDocument(document)
    setPassword(password)
    setFormErrors((prev) => ({
      ...prev,
      ...(document ? { document: '' } : {}),
      ...(password ? { password: '' } : {}),
      submit: '',
    }))
  }

  const handleRegister = () => {
    navigate('/signup')
  }

  const handleForgotPassword = () => {
    navigate('/forgot-password')
  }

  const handleSignInClick = async (document, password) => {
    // check if first signin
    const errors = {}
    if (!document) errors.document = 'Debe ingresar su documento'
    if (!password) errors.password = 'Debe ingresar su contraseña'
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors)
      return
    }

    setFormErrors({})
    setLoaded(true)
    try {
      let userDoc = await getUserByDocumentAndCode(document, password)
      if (userDoc) {
        navigate(`/activar-funcionario?document=${document}&code=${password}`)
      } else {
        userDoc = await getUserByDocument(document)
        if (userDoc) {
          const email = userDoc.data().email
          await dispatch(signIn({ email, password })).unwrap()
        } else {
          setFormErrors({ submit: 'Credenciales incorrectas' })
        }
      }
    } catch (error) {
      setFormErrors({})
    } finally {
      setLoaded(false)
    }
  }

  return (
    <AuthTemplate
      disbledSubmit={loaded}
      description="Inicie sesión para acceder a su panel"
      form={signinForm}
      submitLabel="Ingresar"
      topbarTitle="Iniciar sesión"
      onChange={(value) => handleValueChange(value)}
      onSubmit={() => handleSignInClick(document, password)}
      formErrors={formErrors}
    >
      <StyledButtons>
        {SIGN_UP_ENABLED && (
          <Label color="grey" onClick={() => handleRegister()} nowrap underline>
            Registrarse como funcionario
          </Label>
        )}
        <Label color="grey" onClick={() => handleForgotPassword()} nowrap underline>
          Olvidé mi contraseña
        </Label>
      </StyledButtons>
      {formErrors.submit ? (
        <SubmitError color="alert">
          {formErrors.submit}
        </SubmitError>
      ) : null}
      {loaded && <Loader />}
    </AuthTemplate>
  )
}

export default SigninScreen
